import { Box, styled, Typography } from '@mui/material'

import CloudflareImage from '@ecm/ui/element/CloudflareImage'
import Color from '@ecm/ui/element/Color'
import MainContainer from '@ecm/ui/element/MainContainer'

import nationalForestFoundationLogo from '/public/images/logo/national-forest-foundation.svg'

type NFFBannerProps = {
  className?: string
}

const NFFBanner = styled(({ className }: NFFBannerProps) => (
  <Box className={className} p={{ md: '4em 0 10em', xs: '1em 0 10em' }}>
    <MainContainer>
      <Box
        className="banner"
        m="0 auto"
        p={{ lg: '3em', xs: '1.5em' }}
        display="grid"
        gap={{ lg: '3em', xs: '1.5em' }}
        gridTemplateColumns={{ md: '1fr 2fr', sm: '1fr' }}
        alignItems="center"
        borderRadius="8px"
        maxWidth="1010px"
      >
        <CloudflareImage src={nationalForestFoundationLogo} />
        <Typography
          variant="p1"
          color={Color.white.normal}
          textAlign={{ md: 'unset', xs: 'center' }}
          my="0.5em"
        >
          We partnered with the National Forest Foundation to
          <b> plant 10,000 trees in areas affected by wildfires, </b>
          including California, Washington, Colorado, and 17 other states.
        </Typography>
      </Box>
    </MainContainer>
  </Box>
))({
  '.banner': {
    background: 'linear-gradient(272.99deg, #4EDF97 -12.1%, #0F2272 100%)',
  },
  backgroundImage: "url('/images/illustration/forest.svg')",
  backgroundPosition: 'bottom',
  backgroundRepeat: 'repeat-x',
})

export default NFFBanner
